import { MenuItem } from "@mui/material";
import { Stack } from "@mui/system";
import moment from "moment";
import { useState } from "react";
import TableInput from "../../../../../common/TableInput";
import DatePickerMui from "../../../../../common/DatePickerMui";
import TableCompHead from "../../../../../common/TableCompHead";
import CustomSelect from "../../../../../common/CustomSelect";
import formatDate from "../../../../../components/Control/formatDate";
import { useQuery } from "../../../../../components/Control/useQuery";

const tableHead = {
  setup: ["FRM-CMT-04", "00", "01-04-2023"],
  retro: ["", "00", "01-04-2023"],
  suspected: ["", "00", "01-04-2023"],
};

const heading = {
  setup: "SETTING APPROVAL RECORDS",
  retro: "RETROACTIVE CHECK INSPECTION RECORDS",
  suspected: "SUSPECTED CHECK RECORDS",
};
const THead = ({ getProcess, moduleData, isView, operation }) => {
  const [render, setRender] = useState(false);
  const query = useQuery();
  const documentType = query.get("documentType");
  const machineName = query.get("machine_name");
  const operation_name = query.get("operation_name");
  return (
    <thead>
      <TableCompHead
        colSpan={18}
        rowSpan={3}
        labels={["Doc No", "Rev", "Eff. Date"]}
        values={tableHead[documentType]}
        heading={heading[documentType]}
      />
      <tr>
        <th align="left" colSpan={4}>
          Customer Name:
          {moduleData?.customer_name ||
            moduleData.part_id?.customer_id?.customer_name}
        </th>
        <th align="left" colSpan={7}>
          Machine Name:{machineName}
        </th>
        <th colSpan={7} align="left">
          <Stack style={{ gap: "5px" }}>
            Date:-
            {isView ? (
              formatDate(moduleData.date)
            ) : (
              <DatePickerMui
                value={moduleData.date}
                onChange={(date) => {
                  moduleData.date = date;
                  setRender((prev) => !prev);
                }}
              />
            )}
          </Stack>
        </th>
      </tr>
      <tr>
        <th colSpan={4} align="left">
          Operation Name & No. :
          {isView ? (
            moduleData.operation_name
          ) : (
            <CustomSelect
              name="operation_name"
              value={moduleData.operation_name || operation_name || ""}
              onChange={(e) => {
                getProcess(e.target.value);
                setRender((prev) => !prev);
              }}
            >
              <MenuItem value="">None</MenuItem>
              {operation.map((name) => (
                <MenuItem value={name}>{name}</MenuItem>
              ))}
            </CustomSelect>
          )}
        </th>
        <th colSpan={7}></th>
        <th colSpan={7} align="left">
          Sample Size :
          <TableInput
            isView={isView}
            name="sample_size"
            type="text"
            value={moduleData?.sample_size}
            onChange={(e) => {
              moduleData.sample_size = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={4} align="left">
          PART NAME: {moduleData.part_name || moduleData.part_id?.part_name}
        </th>
        <th colSpan={7} align="left">
          PART NO: {moduleData?.part_number || moduleData.part_id?.part_number}
        </th>

        <th colSpan={7} align="left"></th>
      </tr>
      <tr>
        <th rowSpan={2}>S.NO.</th>
        <th colSpan={2}>DESCRIPTION</th>
        <th rowSpan={2}>METHOD</th>
        <th colSpan={10}>OBSERVATIONS</th>
        <th rowSpan={2}>STATUS</th>
        <th rowSpan={2}>APPROVAL BY</th>
        <th rowSpan={2}>REMARKS</th>
        <th rowSpan={2}>ACTION</th>
      </tr>
      <tr>
        {["PARAMETER", "SPECIFICATION", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(
          (head, index) => (
            <th
              key={head + index + "heading"}
              style={{ textTransform: "uppercase" }}
            >
              {head}
            </th>
          ),
        )}
      </tr>
    </thead>
  );
};

export default THead;
